import React, { useContext, useState } from 'react'
import { Formik } from 'formik'
import { Button, Form, NotificationInline, NotificationManagerContext,
   Spacer, Text, View } from 'oio-react'
import PropTypes from 'prop-types'
import { Select } from 'src/sites/kits/Utils/ConnectedForm'
import { useReportInitiativeMessage } from 'src/core/graphql/hooks'

const ReportInitiativeMessage = ({ onCancelButtonClick, onReport, messageId, replyId }) => {
   const { showNotification } = useContext(NotificationManagerContext)
   const [error, setError] = useState(null)
   const { reportInitiativeMessage } = useReportInitiativeMessage()

   const handleReportInitiativeMessage = async (values, actions) => {
      if (values.reason === '') {
         setError('Please choose a reason')
         return actions.setSubmitting(false)
      }

      if (replyId) {
         values.replyId = replyId
      }

      try {
         await reportInitiativeMessage({
            ...values,
            messageId
         })

         showNotification({
            message: 'This message has been reported',
            title: 'Reported!',
            type: 'success'
         })

         onReport()
      } catch (err) {
         setError(err.message)
      } finally {
         actions.setSubmitting(false)
      }
   }

   return (
      <Formik
         initialValues={{ reason: '' }}
         onSubmit={handleReportInitiativeMessage}
         render={({ handleSubmit, isSubmitting }) => (
            <Form
               elementAppearance="plain"
               elementBackgroundColor="#eee"
               elementFocusBackgroundColor="#f3f3f3"
               labelTextColor="#333"
               labelTextSize="1.5"
               labelTextTransform="none"
               labelTextWeight="medium"
               onSubmit={handleSubmit}>
               <View
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  height="50px"
                  padding="0px 15px"
                  borderBottom="1px solid #eee">
                  <Text size="2.5" weight="medium">
                     Report this Message
                  </Text>
               </View>
               <View
                  maxHeight="calc(100vh - 150px)"
                  scroll="on">
                  {error && (
                     <NotificationInline
                        textSize="1.5"
                        type="error"
                        title="An error occured"
                        message={error}
                     />
                  )}
                  <View padding="20px">
                     <Text size="1.5">
                        Why are you reporting this message?
                     </Text>
                     <Spacer size="2" />
                     <Select name="reason">
                        <option disabled value="">
                           Please choose an option (required)
                        </option>
                        <option value="This message is inappropriate/contains harmful content">
                           This message is inappropriate/contains harmful content
                        </option>
                        <option value="This user is posting spam">
                           This user is posting spam
                        </option>
                        <option value="This user feels like a bot">
                           This user feels like a bot
                        </option>
                        <option value="Other">Other</option>
                     </Select>
                  </View>
               </View>
               <View
                  display="flex"
                  justifyContent="flex-end"
                  alignItems="center"
                  padding="10px[a-b] 10px 10px 10px 60px[c-f]"
                  borderTop="1px solid #eee">
                  <Button
                     onClick={onCancelButtonClick}
                     width="48%[a-b] auto[c-f]"
                     size="sm"
                     name="Cancel"
                     color="#fff"
                     textColor="#666"
                  />
                  <View display="inline-block" width="2%" height="12px" />
                  <Button
                     mode={isSubmitting ? 'loading' : 'normal'}
                     width="50%[a-b] auto[c-f]"
                     size="sm"
                     type="submit"
                     name="Report"
                     color="red"
                     textColor="#fff"
                  />
               </View>
            </Form>
         )}
      />
   )
}

ReportInitiativeMessage.propTypes = {
   onCancelButtonClick: PropTypes.func.isRequired,
   onReport: PropTypes.func.isRequired,
   messageId: PropTypes.string.isRequired,
   replyId: PropTypes.string
}

ReportInitiativeMessage.defaultProps = {
   replyId: undefined
}

export default ReportInitiativeMessage
